import React from 'react'
import { ResponsiveContainer, LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line } from 'recharts'

const Chart = ({ data }) => {
    return <>
      { data && <ResponsiveContainer width={'100%'} height={400}>
          <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis yAxisId="left" />
              <YAxis yAxisId="right" orientation="right" />
              <Tooltip />
              <Legend />
              <Line yAxisId="left" type="monotone" dataKey="impressions" stroke="#82ca9d" />
              <Line yAxisId="right" type="monotone" dataKey="clicks" stroke="#8884d8" />
          </LineChart>
      </ResponsiveContainer> || null }
    </>
}

export default Chart
